<link rel="stylesheet" href="sidebar-navigation.component.css" />
<div class="main-container mat-app-background">
  @if (isMenuVisible) {
    <mat-toolbar class="primary mat-elevation-z2" color="primary">
      <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <button class="pwa-back-button" mat-icon-button (click)="navigateBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <ldw-logo></ldw-logo>
      <div class="doublelined">
        <div class="webdoku showIfEmpty">{{ webDokuName }}</div>
        <div class="infotext showIfEmpty">{{ infoText }}</div>
      </div>
      <span class="spacer"></span>
      @if (planningJobSelectionVisible) {
       <ldw-planning-job-select
            [initialValue]="selectedPlanningJob()?.name || ''"
            (jobChanged)="jobHasChanged($event)"
            />
      }
      <ldw-messages-button></ldw-messages-button>
      @if (searchButtonVisible) {
        <button
          mat-icon-button
          [routerLink]="menuService.cmdSearch.route"
          routerLinkActive="active-link"
          matTooltip="{{ showToolTip()? ('SEARCH.SEARCH' | translate):'' }}"
          >
          <mat-icon>{{ menuService.cmdSearch.icon }}</mat-icon>
        </button>
      }
      @if (bookmarkService.bookmarksAvailable) {
        <ldw-document-bookmarks-button></ldw-document-bookmarks-button>
      }
      @if (loading$ | async) {
        <mat-progress-bar mode="indeterminate" class="loadingbar"></mat-progress-bar>
      }
    </mat-toolbar>
  }

  <mat-sidenav-container class="sidenav-container" [hasBackdrop]="hasBackdrop" (backdropClick)="closeBackdrop(true)" [autosize]="true">
    @if (isMenuVisible) {
      <mat-sidenav #sidenav opened="true" mode="side" disableClose>
        <mat-nav-list class="nav-list">
          @for (mitem of availableItems$ | async; track mitem) {
            <div>
              <a
                class="nav-list-item"
                mat-list-item
                [routerLink]="mitem.route"
                routerLinkActive="active-link"
                (click)="closeBackdrop(false)"
                >
                <mat-icon>{{ mitem.icon }}</mat-icon>
                <span>&nbsp;{{ mitem.text }}</span>
              </a>
            </div>
          }
          @if (isWebDokuAvailable) {
            <ldw-menu [menuItems]="infoCommands">
              <a mat-list-item>
                <mat-icon>info</mat-icon>
                <span>&nbsp;Info</span>
              </a>
            </ldw-menu>
          }
          <ldw-menu [menuItems]="userCommands">
            <a mat-list-item>
              <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
              <span>&nbsp;{{ menuService.cmdUser.text }}</span>
            </a>
          </ldw-menu>
          <span class="spacer"></span>
          <span mat-list-item class="bottomtext"> <mat-icon class="bar-icon">person</mat-icon>{{ userName }} </span>
        </mat-nav-list>
      </mat-sidenav>
    }

    <mat-sidenav-content class="main-outlet-container">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
